import React, { useState } from 'react';
import { ask__ } from './../../shared/utils/i18n.js';

import Select, { components } from 'react-select';
import Icon from '../Icon/Icon';

import './Dropdown.scss';

const DropdownIndicator = props => {
  return (
    components.DropdownIndicator && (
      <components.DropdownIndicator {...props}>
        <Icon name="caret-down" />
      </components.DropdownIndicator>
    )
  );
};

const ClearIndicator = props => {
  return (
    components.ClearIndicator && (
      <components.ClearIndicator {...props}>
        <Icon name="close" />
      </components.ClearIndicator>
    )
  );
};

export default function Dropdown(props) {

  const {
    label,
    value,
    options,
    isLoading,
    onNewValue,
    formatOptionLabel
  } = props;

  // const [isActive,    setIsActive]   = useState(false);
  const [selectedValue,    setSelectedValue]   = useState(value);

  // hide options with "is_phone_consultation: true" flag
  const cleanOptions = options.filter(option => !option.is_phone_consultation);

  const selectedOptionValue = cleanOptions.find(option => option.value === value?.value) || null;



  return (
    <Select
      className={selectedOptionValue ? 'filter filter--active' : 'filter'}
      classNamePrefix="filter"
      value={selectedOptionValue}
      onChange={selectedOption => {
        setSelectedValue(selectedOption);
        if (typeof onNewValue == 'function') {
          onNewValue(selectedOption);
        }
      }}
      options={cleanOptions}
      isLoading={isLoading}
      hideSelectedOptions={false}
      isClearable={true}
      placeholder={<><Icon name="search" />{label}</>}
      formatOptionLabel={formatOptionLabel}
      loadingMessage={() => ask__('Booking: Loading message')}
      noOptionsMessage={() => ask__('Booking: No options')}
      components={{ DropdownIndicator, ClearIndicator }}
    />
  )

}
